"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeHours = exports.getCombinationsWithComponents = exports.getTz = void 0;
exports.getCombinations = getCombinations;
const fp_1 = require("lodash/fp");
// AEST is UTC+10:00, AEDT is UTC+11:00
const getTz = () => (new Date().getTimezoneOffset() === -600 ? 'AEST' : 'AEDT');
exports.getTz = getTz;
function getCombinations(base, suffixes) {
    const baseKeys = Object.keys(base);
    const suffixKeys = Object.keys(suffixes);
    return baseKeys.reduce((combinations, baseKey) => (Object.assign(Object.assign({}, combinations), suffixKeys.reduce((newCombinations, suffixKey) => (Object.assign(Object.assign({}, newCombinations), { [`${baseKey}_${suffixKey}`]: `${base[baseKey]}-${suffixes[suffixKey]}` })), {}))), {});
}
const getCombinationsWithComponents = (hospitalProducts, extrasProducts) => (0, fp_1.reduce)((result, hospital) => {
    const combinations = (0, fp_1.reduce)((acc, extras) => (0, fp_1.set)(`${hospital}-${extras}`, { hospital, extras }, acc), {}, extrasProducts);
    return (0, fp_1.assign)(result, combinations);
}, {}, hospitalProducts);
exports.getCombinationsWithComponents = getCombinationsWithComponents;
const makeHours = (from, to, openingDays = 'Monday to Friday') => ({ from, to, openingDays });
exports.makeHours = makeHours;
